"use client";

import { useEffect, useState } from "react";
import { GoogleAnalytics as GA } from "@next/third-parties/google";
import { safeGetItem } from "@/lib/safeStorage";

const COOKIE_CONSENT_KEY = "velyq-cookie-consent";

/**
 * Google Analytics component that respects cookie consent
 * Only loads GA4 after user has accepted cookies
 */
export function GoogleAnalytics() {
  const [hasConsent, setHasConsent] = useState(false);
  const gaId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

  useEffect(() => {
    // Check consent on mount
    const consent = safeGetItem(COOKIE_CONSENT_KEY);
    if (consent === "accepted") {
      setHasConsent(true);
    }

    // Listen for consent changes (when user clicks "Compris")
    const handleStorageChange = () => {
      const newConsent = safeGetItem(COOKIE_CONSENT_KEY);
      if (newConsent === "accepted") {
        setHasConsent(true);
      }
    };

    // Custom event for same-tab consent
    window.addEventListener("storage", handleStorageChange);
    
    // Also check periodically in case localStorage was updated in same tab
    const interval = setInterval(() => {
      const consent = safeGetItem(COOKIE_CONSENT_KEY);
      if (consent === "accepted" && !hasConsent) {
        setHasConsent(true);
      }
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [hasConsent]);

  // Don't render if no GA ID or no consent
  if (!gaId || !hasConsent) {
    return null;
  }

  return <GA gaId={gaId} />;
}
